import type {
	FileMetadata,
	GetFileMetadataRequest,
	GetSingleFileUrlRequest,
	GetUploadUrlRequest,
} from "@somewear/api";

export interface FileMetadataWithState extends FileMetadata.AsObject {
	state: FileState;
	requestId?: string;
	file?: File;
}

export enum FileState {
	Pending = "pending",
	Error = "error",
	Success = "success",
}

export interface UploadFileRequest {
	senderId: string;
	workspaceId?: GetUploadUrlRequest.AsObject["workspaceId"];
	conversationId?: GetUploadUrlRequest.AsObject["conversationId"];
	file: File;
	/** id of the errored file entity this upload retries; it's removed when the retry kicks off */
	retryOfFileId?: string;
}

export type UploadFileResponse = {
	signedUploadUrl: string;
	fileMetadata: FileMetadata.AsObject;
};

export type GetConversationFilesResponse = FileMetadata.AsObject[];

export interface GetConversationFilesRequestPayload {
	workspaceId?: GetFileMetadataRequest.AsObject["workspaceId"];
	conversationId?: GetFileMetadataRequest.AsObject["conversationId"];
}

export interface DownloadFileRequestPayload {
	fileName?: string;
	fileId: string;
	workspaceId?: GetSingleFileUrlRequest.AsObject["workspaceId"];
	conversationId?: GetSingleFileUrlRequest.AsObject["conversationId"];
}

export type DownloadFileResponse = string;
